export default "__VITE_ASSET__d7a17796__"